import PropTypes from 'prop-types';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCloseReadingProgressText } from 'a/hub/selectors/';
import { useFirstUserInteraction } from 'lib/hooks';
import { clearSessionProgress } from 'a/hub/actions/studentProgressActions';
import { BaseEarlyExitModal, FractionText, PortalIcon } from '../sharedComponents';

const TFEEarlyExitModal = ({ closeModal, config }) => {
  const fractionText = useSelector(getCloseReadingProgressText);

  const dispatch = useDispatch();

  const { heading = 'Great work!', text = 'You have completed more of the *Four Eyes* mission.' } =
    config;

  const firstUserInteraction = useFirstUserInteraction();

  const onClick = (e) => {
    dispatch(clearSessionProgress());
    firstUserInteraction(e);
    closeModal(e);
  };

  return (
    <BaseEarlyExitModal
      headerText={heading}
      descriptionText={text}
      onConfirm={onClick}
      actionScope="tfe-early-exit-modal"
    >
      <PortalIcon top={198} left={323} completeRatio={0.5} />
      <FractionText top={333} left={361}>
        {fractionText}
      </FractionText>
    </BaseEarlyExitModal>
  );
};

TFEEarlyExitModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  config: PropTypes.object.isRequired,
};

export default TFEEarlyExitModal;
